import styles from "./duets-result-model.module.scss";
import ShareButton from "@/components/common/command-buttons/share-button";
import { useClipboard } from "@/hooks/use-clipboard";
import DownloadButton from "@/components/common/command-buttons/download-button";
import { VoiceModel } from "@/actions/db/get-models";
import React, { useEffect, useState } from "react";
import DuetsVoiceCard from "@/components/pages/duets/components/duets-voice-card";
import TabButton from "@/components/common/tab-button";
import WaveSurferPlayer from "@/components/common/music-player/wave-surfer-player";
import WavesurferProvider from "@/hooks/providers/wavesurfer-provider";
import { useDownload } from "@/hooks/use-download";
import { getFileNameFromUrl } from "@/utils/history-helper";
import Image from "next/image";
import shareIcon from "@/assets/icons/share-icon.svg";
import ShareCoverButton from "@/components/common/share-cover-button";

type DuetsResultTab = "Combined" | "Instrumentals";

interface DuetsResultModalProps {
  id?: string;
  voices: VoiceModel[];
  combinedUrl: string;
  instrumentalUrl: string;
}

const DuetsResultModal = ({
  id,
  voices,
  combinedUrl,
  instrumentalUrl,
}: DuetsResultModalProps) => {
  const { download } = useDownload();

  const [selectedTab, setSelectedTab] = useState<DuetsResultTab>("Combined");
  const [selectedUrl, setSelectedUrl] = useState<string>(combinedUrl);

  useEffect(() => {
    setSelectedUrl(selectedTab === "Combined" ? combinedUrl : instrumentalUrl);
  }, [combinedUrl, instrumentalUrl, selectedTab]);

  const handleDownload = async () => {
    await download(selectedUrl, getFileNameFromUrl(selectedUrl, selectedTab));
  };
  return (
    <WavesurferProvider>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <div className={styles.result_title}>
            {getFileNameFromUrl(selectedUrl, selectedTab)}
          </div>
          <div className={styles.buttons_wrapper}>
            <ShareCoverButton
              featureType={"duets"}
              contentId={id}
              url={selectedUrl}
            >
              <Image src={shareIcon} alt={""} />
            </ShareCoverButton>
            <DownloadButton
              isEnabled={true}
              handleClick={handleDownload}
              hideText={true}
            />
          </div>
        </div>
        <div className={styles.voice_models}>
          {voices.map((voice: VoiceModel, index) => (
            <div key={voice.name} className={styles.selected_voice}>
              <DuetsVoiceCard voice={voice} voiceIndex={index} />
            </div>
          ))}
        </div>
        <div className={styles.type_buttons}>
          <TabButton<DuetsResultTab>
            type={"Combined"}
            selectedSubtype={selectedTab}
            setSubtype={(tab) => setSelectedTab(tab)}
            overriddenNotSelected={styles.not_selected_button}
          />
          <TabButton<DuetsResultTab>
            type={"Instrumentals"}
            selectedSubtype={selectedTab}
            setSubtype={(tab) => setSelectedTab(tab)}
            overriddenNotSelected={styles.not_selected_button}
          />
        </div>
        <WaveSurferPlayer url={selectedUrl} />
      </div>
    </WavesurferProvider>
  );
};

export default DuetsResultModal;
